module.exports = __webpack_public_path__ + "img/aej1n-66wvl.033.e1f72351.png";